var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.6111V17.5H10.8333L15.8333 12.5V11.6667H11.9444C11.0278 11.6667 10.5695 11.6667 10.2848 11.9514C10 12.2362 10 12.6945 10 13.6111Z",
    fill: "#7E869E",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1433 17.5H7.50033C5.92898 17.5 5.1433 17.5 4.65515 17.0118C4.16699 16.5237 4.16699 15.738 4.16699 14.1667V5.83333C4.16699 4.26199 4.16699 3.47631 4.65515 2.98816C5.1433 2.5 5.92898 2.5 7.50033 2.5H12.5003C14.0717 2.5 14.8573 2.5 15.3455 2.98816C15.8337 3.47631 15.8337 4.26199 15.8337 5.83333V11.8096C15.8337 12.1503 15.8337 12.3206 15.7702 12.4737C15.7068 12.6269 15.5864 12.7473 15.3455 12.9882L11.3218 17.0118C11.081 17.2527 10.9605 17.3731 10.8074 17.4366C10.6542 17.5 10.4839 17.5 10.1433 17.5Z",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5V13.6111C10 12.6945 10 12.2362 10.2848 11.9514C10.5695 11.6667 11.0278 11.6667 11.9444 11.6667H15.8333",
    stroke: "#222222",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactSheet);
export default __webpack_public_path__ + "static/media/FactSheet.7ac8d43f987f3ab3d62b304e4e8e951b.svg";
export { ForwardRef as ReactComponent };